var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoneNumber = function SvgPhoneNumber(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.0025 34.9439C36.2425 34.8039 34.5025 34.5039 32.8025 34.0439L30.4225 36.4239C32.8225 37.2439 35.3825 37.7639 38.0225 37.9239V34.9439H38.0025ZM10.0625 10.0039C10.2425 12.6439 10.7625 15.1839 11.5625 17.6039L13.9625 15.2039C13.5025 13.5239 13.2025 11.7839 13.0825 10.0039H10.0625Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.14 15.14C17.3813 12.8361 16.9964 10.4256 17 8C17 6.9 16.1 6 15 6H8C6.9 6 6 6.9 6 8C6 26.78 21.22 42 40 42C41.1 42 42 41.1 42 40V33.02C42 31.92 41.1 31.02 40 31.02C37.52 31.02 35.1 30.62 32.86 29.88C32.6615 29.808 32.4511 29.7741 32.24 29.78C31.72 29.78 31.22 29.98 30.82 30.36L26.42 34.76C20.7509 31.8608 16.1392 27.2491 13.24 21.58L17.64 17.18C18.2 16.62 18.36 15.84 18.14 15.14ZM32.8 34.04C34.5 34.52 36.24 34.82 38 34.94V37.92C35.36 37.74 32.82 37.22 30.4 36.42L32.8 34.04ZM11.58 17.6C10.76 15.18 10.24 12.64 10.06 10H13.06C13.1907 11.7533 13.499 13.4889 13.98 15.18L11.58 17.6Z",
    fill: "#656565"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneNumber);
export default ForwardRef;